import { render, staticRenderFns } from "./MinusIcon.vue?vue&type=template&id=4b524bbe"
import script from "./MinusIcon.vue?vue&type=script&lang=js"
export * from "./MinusIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports